export enum PoolActivityTab {
  ALL_ACTIVITY = 'allActivity',
  USER_ACTIVITY = 'userActivity'
}
